export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/environments/environment.ts